var exports = {
  "link": "x24da60e8--feb46d--link",
  "primary": "x24da60e8--feb46d--primary",
  "disabled": "x24da60e8--feb46d--disabled",
  "white": "x24da60e8--feb46d--white",
  "before-icon": "x24da60e8--feb46d--before-icon",
  "after-icon": "x24da60e8--feb46d--after-icon",
};

module.exports = exports;
